/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FlavorsInputs */

const en_flavors = /** @type {(inputs: FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flavors`)
};

const es_flavors = /** @type {(inputs: FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabores`)
};

/**
* | output |
* | --- |
* | "Flavors" |
*
* @param {FlavorsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const flavors = /** @type {((inputs?: FlavorsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FlavorsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flavors(inputs)
	return es_flavors(inputs)
});